import { useCampaignsStore } from '@/stores/campaigns'

// Runs only on the client, after 01-site-meta-data has seeded campaigns.campaigns.
// checkCampaignStatus updates cookie-persisted fields and must have a Nuxt instance
// (calling it in the async site-meta plugin after await $fetch breaks useCookie).
export default defineNuxtPlugin((nuxtApp) => {
	const campaigns = useCampaignsStore(nuxtApp.$pinia)

	if (Object.keys(campaigns.campaigns).length > 0) {
		campaigns.checkCampaignStatus()
	} else {
		campaigns.isLoading = false
	}
})
